export default __webpack_public_path__ + "static/bakstol-50f334e4f33e1e6f39e2307945795813.png";